import React, { forwardRef } from "react";
import "./ImageWithBoxes.css";

/**
 * Renders textual (factsExplanation) reasoning entries for the hovered segment.
 *
 * Props:
 *   explanations — array of factsExplanation entries (each with text, category, reasoning, source_type, confidence)
 *   hoveredId    — currently hovered segment id (for border colour)
 */
const TextualExplanation = forwardRef(
  ({ explanations, hoveredId, showMetadata = true }, ref) => {
    const entries = explanations || [];

    return (
      <div ref={ref} className="explanation-panel">
        <div className="explanation-panel__header">
          <h2 className="explanation-panel__title">Why This Caption Part Was Highlighted</h2>
          {entries.length > 0 && (
            <span className="explanation-panel__count">
              {entries.length} {entries.length === 1 ? "reason" : "reasons"}
            </span>
          )}
        </div>
        <div className="visual-scroll-container explanation-panel__body">
          {entries.length === 0 && (
            <p className="explanation-empty-state">
              Hover over a highlighted word to inspect the AI's support for that caption part.
            </p>
          )}
          {entries.map((entry, idx) => (
            <article key={idx} className="explanation-card">
              <div className="explanation-card__header">
                <span className="explanation-card__target">{entry.text}</span>
                {showMetadata && entry.source_type && (
                  <span className="explanation-chip">{entry.source_type}</span>
                )}
                {showMetadata && entry.confidence != null && (
                  <span className="explanation-chip explanation-chip--score">
                    ({Math.round(entry.confidence * 100)}%)
                  </span>
                )}
              </div>
              <p className="explanation-card__reasoning">
                {entry.reasoning}
              </p>
            </article>
          ))}
        </div>
      </div>
    );
  }
);

TextualExplanation.displayName = "TextualExplanation";

export default TextualExplanation;
